import api from './api';

// Funnel Résiliation
export const checkUser = async (data) => {
    var payment = await api.post("api/PaySafe/CheckUser",
        data,
        {
            headers: {
                Accept: "application/json",
            },
        }).catch((error) => {
            return false;
        });
    if (payment.data) return payment.data;
    else return false;
}

// Funnel Résiliation
export const proceedPaySafePayment = async (data) => {
    var payment = await api.post("api/PaySafe/ProceedPayment",
        data,
        {
            headers: {
                Accept: "application/json",
            },
        }).catch((error) => {
            return false;
        });
    if (payment.data) return payment.data;
    else return false;
}